import {FC, SVGProps} from 'react';

export const EditIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden {...props}>
		<path d="M20 20H4V22H20V20Z" fill="currentColor" />
		<path
			d="M18.8691 6.44434L8.11328 17.2002H4.7998V13.8867L15.5557 3.13086L18.8691 6.44434Z"
			stroke="currentColor"
			strokeWidth="1.6"
		/>
	</svg>
);
